
const Product = (state) => state.Product;
const Products = (state) => state.Products;
const TotalInfo = (state) => state.TotalInfo;
export default { Product, Products, TotalInfo }